import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const AnimalsEyeIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                d='M12 4.99963C18.3632 4.99963 22.8186 12 22.8186 12C22.8186 12 19.5731 19.0004 12 19.0004C4.36362 19.0004 1.1814 12 1.1814 12C1.1814 12 5.57231 4.99963 12 4.99963ZM12 16.4542C14.4818 16.4542 16.4541 14.4819 16.4541 12C16.4541 9.51822 14.4818 7.5459 12 7.5459C9.51817 7.5459 7.54585 9.51822 7.54585 12C7.54585 14.4819 9.51817 16.4542 12 16.4542Z'
                fill='currentColor'
            />
            <Path
                d='M10.0909 12C10.0909 13.0548 10.9452 13.9091 12 13.9091C13.0547 13.9091 13.9091 13.0548 13.9091 12C13.9091 10.9452 13.0547 10.0909 12 10.0909C10.9452 10.0909 10.0909 10.9452 10.0909 12Z'
                fill='currentColor'
            />
        </>
    ),
})

AnimalsEyeIcon.displayName = 'AnimalsEyeIcon'
